import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

class StarRating extends React.Component {
  constructor(props) {
    super(props)
    this.starClick = this.starClick.bind(this)
    this.mobileStarClick = this.mobileStarClick.bind(this)
    this.starSelected = this.starSelected.bind(this)
  }

  starClick(name) {
    this.props.setParentState({ starValue: name })
  }

  mobileStarClick(val) {
    if ("ontouchstart" in window.document) {
      this.starClick(val)
    }
  }

  starSelected(val) {
    return val <= this.props.state.starValue
  }

  render() {
    return (
      <div id="star-rating-review" className="center">
        <div className="rating">
          <div
            className={classNames("star", {
              "star-selected": this.starSelected(5),
            })}
            onClick={() => this.starClick(5)}
            onMouseOver={() => this.mobileStarClick(5)}
            title="Awesome"
            data-toggle="tooltip"
            data-placement="bottom"
          />
          <div
            className={classNames("star", {
              "star-selected": this.starSelected(4),
            })}
            onClick={() => this.starClick(4)}
            onMouseOver={() => this.mobileStarClick(4)}
            title="Pretty Good"
            data-toggle="tooltip"
            data-placement="bottom"
          />
          <div
            className={classNames("star", {
              "star-selected": this.starSelected(3),
            })}
            onClick={() => this.starClick(3)}
            onMouseOver={() => this.mobileStarClick(3)}
            title="Alright"
            data-toggle="tooltip"
            data-placement="bottom"
          />
          <div
            className={classNames("star", {
              "star-selected": this.starSelected(2),
            })}
            onClick={() => this.starClick(2)}
            onMouseOver={() => this.mobileStarClick(2)}
            title="Not Great"
            data-toggle="tooltip"
            data-placement="bottom"
          />
          <div
            className={classNames("star", {
              "star-selected": this.starSelected(1),
            })}
            onClick={() => this.starClick(1)}
            onMouseOver={() => this.mobileStarClick(1)}
            title="Bad Experience"
            data-toggle="tooltip"
            data-placement="bottom"
          />
        </div>
      </div>
    )
  }
}

StarRating.propTypes = {
  setParentState: PropTypes.func.isRequired,
  state: PropTypes.shape({
    starValue: PropTypes.number,
  }).isRequired,
}

export default StarRating
